<template>
    <div>
        <el-table
            :data="users"
            @sort-change="onSortChange"
            row-key="id"
            v-loading="loading"
            ref="table"
        >
            <el-table-column
                label="Name"
                prop="name"
                sortable="custom"
                width="175"
            />
            <el-table-column
                label="Email"
                prop="email"
                sortable="custom"
                min-width="150"
            />
            <el-table-column
                label="Username"
                prop="username"
                sortable="custom"
                width="175"
            />
            <el-table-column
                label="Phone"
                prop="phone_number"
                sortable="custom"
                width="140"
            />
            <el-table-column
                label="Role"
                prop="role_description"
                sortable="custom"
                min-width="180"
            />
            <el-table-column
                label="Status"
                prop="status"
                sortable="custom"
                width="100"
            >
                <template slot-scope="scope">
                    <el-tag :type="scope.row.is_active ? 'success' : 'danger'">
                        {{ scope.row.is_active ? "Active" : "Inactive" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="220">
                <template slot-scope="scope">
                    <div class="action-buttons">
                        <el-button
                            @click="editItem(scope.row)"
                            icon="mdi mdi-pencil"
                            size="small"
                            v-if="canEditUser"
                            type="primary"
                            class="action-button"
                            >Edit</el-button
                        >

                        <el-button
                            :loading="isPasswordResetBusy(scope.row)"
                            @click="resetPassword(scope.row)"
                            icon="mdi mdi-send"
                            size="small"
                            type="danger"
                            class="action-button"
                            >Reset PW</el-button
                        >

                        <div class="link-wrapper">
                            <a
                                href="#"
                                @click.prevent="copyResetUrl(scope.row)"
                                class="copy-link"
                            >
                                <i class="mdi mdi-content-copy"></i> Copy Reset
                                PW URL
                            </a>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <app-pagination
            :pagination="pagination"
            @current-change="onCurrentPageChange"
            class="mt-10"
        />
    </div>
</template>

<script>
export default {
    props: {
        users: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        },
        canEditUser: {
            type: Boolean,
            default: false
        },
        canDeleteUser: {
            type: Boolean,
            default: false
        },
        busyItemsProp: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onSortChange(sort) {
            this.$emit("sort-change", sort);
        },
        editItem(row) {
            this.$emit("edit-item", row);
        },
        resetPassword(row) {
            this.$emit("reset-password", row);
        },
        copyResetUrl(row) {
            this.$emit("copy-reset-url", row);
        },
        isPasswordResetBusy(row) {
            return this.busyItemsProp[`${row.id}_send password reset`];
        },
        onCurrentPageChange(page) {
            this.$emit("current-change", page);
        }
    }
};
</script>

<style scoped>
.action-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.action-button {
    margin-right: 10px;
    margin-bottom: 5px;
}

.link-wrapper {
    width: 100%;
    margin-top: 5px;
}

.copy-link {
    color: #409EFF;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

.copy-link:hover {
    color: #66b1ff;
    text-decoration: underline;
}
</style>
